const collection = {
    slug: "dsm-kei-ninomiya-what-is-our-punk-community-guide",
  
    metaTitle:
      "DSM Kei Ninomiyaとは｜Noir Kei Ninomiyaとの違い・2027SS Our Punkを徹底解説｜買取・レンタル",
  
    metaDescription:
      "DSM Kei Ninomiyaとは何か。Dover Street Market初のオリジナルブランドとして二宮啓が手掛ける新プロジェクトを解説。noir kei ninomiyaとの違い、2027SS「OUR PUNK」までEnclopedia独自の視点で読み解きます。noir kei ninomiya買取・レンタル、デザイナーズブランドの買取・アーカイブレンタルへ案内します。",
  
    metaKeywords:
      "DSM KEI NINOMIYA,DSM Kei Ninomiyaとは,DSM ケイ ニノミヤ,ディーエスエム ケイ ニノミヤ,DMS KEI NINOMIYA,DMS Kei Ninomiyaとは,DMS ケイ ニノミヤ,二宮啓,二宮啓 メンズ,Dover Street Market,Dover Street Market オリジナルブランド,DSM ブランド,DSM Kei Ninomiya 2027SS,DSM Kei Ninomiya OUR PUNK,Our Punk,Pitti Uomo 110,noir kei ninomiya,noir kei ninomiyaとは,noir kei ninomiya メンズ,noir kei ninomiya 違い,ノワールケイニノミヤ,noir kei ninomiya 買取,ノワールケイニノミヤ 買取,noir kei ninomiya 高価買取,noir kei ninomiya レンタル,ノワールケイニノミヤ レンタル,コムデギャルソン 買取,デザイナーズブランド 買取,ファッションアーカイブ レンタル,Enclopedia,アンクロペディア",
  
    canonicalPath:
      "/archive_collection/dsm-kei-ninomiya-what-is-our-punk-community-guide",
  
    heroImage:
      "media/archive_fashion/archive35.png",
  
    heroImageAlt:
      "DSM Kei Ninomiyaとは何か、noir kei ninomiyaとの違いとOur Punkを解説するEnclopediaアーカイブ記事",
  
    heroNumber: "35 / OUR PUNK",
  
    label: "ARCHIVE COLLECTION STUDY",
  
    title:
      "DSM Kei Ninomiyaとは｜二宮啓は、構造を作ることからコミュニティを作ることへ移ったのか",
  
    lead:
      "DSM Kei Ninomiya。\n\nまず、名前を正確に確認する必要があります。\n\nDSMはDover Street Marketの頭文字です。\n\nより日常へ取り入れやすい。\nテーマを持つ。\n年齢やジェンダーを限定しない。\nそして、固定されたブランドの定義に縛られない。\n\n初回となる2026年春夏では、スクールブレザー、トラックスーツ、フットボールシャツ、カレッジニット、プリーツスカート、チームスウェットが並びました。\n\nそこにあったのは、男性服を新しくすることだけではありません。\n\n学校。\nクラブ。\nチーム。\nサポーター。\n店舗スタッフ。\n友人。\n世界各地のDover Street Marketへ集まる人々。\n\n服によって、人がどこに属しているのかを可視化することでした。\n\nそして2027年春夏。\n\nPitti Uomo 110のゲストデザイナーとして発表された初のランウェイには、“OUR PUNK”という名前が付けられました。\n\nタータン。\n安全ピン。\nスタッズ。\nチェーン。\nダメージ加工。\nフットボールシャツ。\n制服。\nVans。\nそして異なる世代のパンクス。\n\nただし、二宮啓が作ろうとしたのは、過去のパンクファッションの再現ではありません。\n\n重要なのは“PUNK”よりも、その前に付いた“OUR”です。\n\n誰か一人のパンクではない。\n1970年代だけのパンクでもない。\n服装によって正解が決まるパンクでもない。\n\n異なる年齢、国籍、身体、スタイルを持つ人々が、それぞれの方法で疑い、壊し、作り直すための共同体。\n\nEnclopediaでは、DSM Kei Ninomiyaを、noirの技術を男性服へ移したブランドではなく、二宮啓が“服の構造”から“服を着る人々の関係”へ研究対象を広げたブランドとして読み解きます。",
  
    keywordLine: [
      "dsm kei ninomiya",
      "our punk",
      "community and belonging",
      "noir buyback rental",
    ],
  
    thesis:
      "noir kei ninomiyaが、素材、接続方法、反復、立体構造によって一着の内部へ新しい秩序を作るブランドだとすれば、DSM Kei Ninomiyaは、制服、スポーツ、音楽、パンク、店舗文化を通して、服の外側にいる人々の間へ暫定的な共同体を作るブランドです。両者は別のブランドですが、“既存の完成形を疑い、異なる要素の接続から新しい関係を作る”という二宮啓の方法では連続しています。",
  
    whyTitle:
      "DSM Kei Ninomiyaは、本当にnoir kei ninomiyaのメンズラインなのか。",
  
    whyBody:
      "DSM Kei Ninomiyaは、Pitti Uomoでメンズコレクションを発表し、フットボールシャツ、トラックジャケット、ブレザー、ワイドパンツなどを展開しています。\n\nそのため、“noir kei ninomiyaのメンズライン”と理解されやすい。\n\nしかし、公式な位置付けは異なります。\n\nDSM Kei Ninomiyaは、noirから派生した男性向けラインではありません。\n\nDover Street Marketが、自らの思想とコミュニティを服として表現するために立ち上げた独立したブランドです。\n\nnoirの主語は、二宮啓自身の探究にあります。\n\n縫わずに服を作ること。\nスタッズやリングによって素材を接続すること。\n黒という制約から構造を際立たせること。\n身体の周囲へ花、球体、棘、ハーネスのような立体を生成すること。\n\n一方、DSM Kei Ninomiyaの主語はDover Street Marketです。\n\nさまざまなブランド、国籍、年齢、職種、サブカルチャーが一つの空間へ集まり、互いの価値観を変化させる場所。\n\n二宮は、自身の造形だけを提示するのではなく、その場所に集まる人々のための服を考えました。\n\nしたがって違いは、レディースとメンズではありません。\n\n誰のために、何を構築するかの違いです。\n\nnoir kei ninomiyaは一着の内部へ構造を作る。\n\nDSM Kei Ninomiyaは、服を着る複数の人々の間へ所属を作る。\n\nEnclopediaでは、この違いをDSM Kei Ninomiyaの出発点として考えます。",
  
    pillars: [
      {
        number: "01",
        title: "NOT A MENS DIFFUSION LINE",
        text:
          "DSM Kei Ninomiyaは、noirのデザインを男性用へ変更したディフュージョンラインではありません。Dover Street Marketの思想を起点とし、年齢やジェンダーを限定しない独立したブランドです。",
      },
      {
        number: "02",
        title: "COMMUNITY BEFORE INDIVIDUAL",
        text:
          "Noir Kei Ninomiyaが二宮啓の個人的な技術研究から始まるのに対し、DSMは店舗、スタッフ、顧客、友人、ブランドが混在する共同体から服を考えます。",
      },
      {
        number: "03",
        title: "THEME AS SHARED LANGUAGE",
        text:
          "学校、フットボール、パンクなど、誰もがある程度理解できる文化的コードを用い、それを異なる人が共有できる服へ変換します。",
      },
      {
        number: "04",
        title: "OUR PUNK",
        text:
          "2027SSの重要語はPUNKだけではありません。OURを付けることで、歴史的な正解を再現するのではなく、現在の共同体が自分たちのパンクを作る余地を残しました。",
      },
    ],
  
    readingTitle:
      "スクールユニフォーム、フットボール、エレファント、Beautiful Chaos、OUR PUNKから読むDSM Kei Ninomiya。",
  
    readingIntro:
      "DSM Kei Ninomiyaを理解するには、noirとの外見的な違いだけでなく、Dover Street Marketが何を目的に作られた場所なのかを見る必要があります。DSMは完成された一つのテイストを販売する店舗ではありません。異なるブランド、人、作品、家具、音楽、価値観を同じ空間へ配置し、衝突させる場所です。その“Beautiful Chaos”を服へ移したとき、必要になったのは単独の傑作ではなく、異なる人々がそれぞれの方法で参加できる共通言語でした。",
  
    observations: [
      {
        index: "01",
        title:
          "正式名称はDMSではなく、DSM Kei Ninomiya",
        text:
          "DMS KEI NINOMIYAやDMS ケイ ニノミヤという表記も見られます。\n\nしかし正式名称はDSM Kei Ninomiyaです。\n\nDSMはDover Street Marketの略称。\n\nブランド名の先頭に二宮啓の名前ではなく、店舗名が置かれていることは重要です。\n\nこれは二宮個人の新ブランドである前に、Dover Street Marketのブランドだからです。\n\n二宮は作者ですが、ブランドの主語はDSMにあります。\n\nそのため、noir kei ninomiyaと同じデザイナーが手掛けていても、目的、対象、商品構成、表現方法は異なります。",
      },
      {
        index: "02",
        title:
          "Dover Street Marketが初めて自らの服を作った",
        text:
          "Dover Street Marketは2004年の開業以来、世界各地のブランドやクリエイターを編集し、独自の売場を作ってきました。\n\nしかし、長い間、DSM自身の恒常的なファッションブランドは存在しませんでした。\n\n店舗のアイデンティティは、商品ではなく選択と配置によって作られていたからです。\n\nどのブランドを入れるのか。\nどの作品を隣に置くのか。\n誰に空間を作らせるのか。\n何を販売し、何を展示するのか。\n\nDSM Kei Ninomiyaは、その編集思想を初めて一つのブランドとして服へ移す試みです。\n\nつまり、これは単なる新規メンズラインではありません。\n\n20年以上、売場として存在してきた思想を、着用できる形へ変換するプロジェクトです。",
      },
      {
        index: "03",
        title:
          "なぜ最初のデザイナーに二宮啓が選ばれたのか",
        text:
          "Dover Street Marketには、COMME des GARÇONSだけでなく、ラグジュアリー、ストリート、若手ブランド、音楽、アートが混在しています。\n\nその最初のブランドを一人のデザイナーへ任せる場合、強すぎる作家性はDSM全体を一つのテイストへ狭める危険があります。\n\n二宮啓の強みは、自身の技術を持ちながら、素材やパーツ同士の関係から形を発生させられることです。\n\n最初から完成形を押し付けるのではなく、接続することで予想外の造形を作る。\n\nその方法は、多様なブランドや人々の共存からアイデンティティを作るDSMの思想と相性がよい。\n\nEnclopediaでは、二宮が選ばれた理由を、noirの知名度だけではなく、“単一の答えを固定しない構築方法”にあると考えます。",
      },
      {
        index: "04",
        title:
          "DSM Kei Ninomiyaは、noirよりアクセスしやすい",
        text:
          "公式には、DSM Kei Ninomiyaはnoirよりアクセスしやすく、テーマ性を持ち、あらゆる年齢やジェンダーへ開かれたブランドと説明されています。\n\nここでの“アクセスしやすい”は、単純に価格が安い、デザインが普通という意味だけではありません。\n\nTシャツ。\nスウェット。\nトラックパンツ。\nフットボールシャツ。\nカーディガン。\nブレザー。\nダッフルコート。\nキャップ。\nソックス。\n\nすでに着方を知っている衣服を入口にしています。\n\nnoirでは、服の構造を理解してから着方を考えることがあります。\n\nDSMでは、日常的な服から入り、その背景にある共同体やテーマへ近づくことができる。\n\n入口の順序が逆なのです。",
      },
      {
        index: "05",
        title:
          "年齢とジェンダーを限定しないことは、サイズ展開だけの話ではない",
        text:
          "DSM Kei Ninomiyaは、メンズウェアの文脈で紹介される一方、公式には年齢やジェンダーを限定していません。\n\n二宮自身も、ジェンダーレスという言葉を設計の中心に置いたというより、DSMへ集まる多様な人々を想定した結果として、着用者を固定しない服を作っています。\n\nプリーツスカート。\nオーバーサイズブレザー。\nフットボールシャツ。\nトラックパンツ。\nスクールタイ。\n\n一般的には性別や年齢によって分類される服を、一つのワードローブへ並べる。\n\n重要なのは、男女どちらでも着られるという商品説明ではありません。\n\n誰が何を着るかをブランド側が決め切らないことです。",
      },
      {
        index: "06",
        title:
          "2026SSの学校は、若さを演出するためのテーマではない",
        text:
          "最初のコレクションには、ブレザー、ネクタイ、カレッジニット、チームスウェット、プリーツスカートなど、学校を連想させる服が並びました。\n\nしかし、単なるプレッピースタイルではありません。\n\n学校は、異なる背景を持つ人間へ共通の服を与え、同じ集団へ所属させる制度です。\n\n制服を着ると、個人差が消えるように見える。\n\n一方で、着崩し方、サイズ、靴、髪型、バッジによって、それぞれの差異も現れます。\n\nDSMも同様です。\n\n異なるブランドや人々が同じ場所へ集まりながら、同一化はされない。\n\n学校というテーマは、DSMという共同体の構造を誰にでも理解できる衣服へ翻訳する方法だったのです。",
      },
      {
        index: "07",
        title:
          "DSMUは、存在しない学校の制服である",
        text:
          "コレクションには、Dover Street Market Universityを示す“DSMU”の文字が使われました。\n\nしかし、実在する大学ではありません。\n\n存在しない学校の名称を付けることで、着る人は架空の共同体へ参加できます。\n\n実際の学校のような入学資格、国籍、年齢、成績は必要ない。\n\n服を選び、着ることが一時的な所属証明になる。\n\nこれはブランドロゴによる所有欲とは少し違います。\n\nロゴを見せて価格や地位を示すのではなく、まだ定義されていない集団へ参加する。\n\nDSM Kei Ninomiyaのロゴは、権威の証明より、参加を促す校章として機能します。",
      },
      {
        index: "08",
        title:
          "象の紋章は、店舗の記憶を世界共通の校章へ変える",
        text:
          "2026SSのクレストには、Dover Street Market Ginzaに設置された象が用いられました。\n\n東京の一店舗に存在する空間的な記憶を、スウェット、ブレザー、Tシャツへ移し、世界各地で共有する。\n\n象を知らない人にとっては、架空の学校やスポーツクラブの紋章に見える。\n\nDSMを知る人にとっては、銀座店の記憶へつながる。\n\n一つの図像が、内部の人間と外部の人間に異なる意味を与えます。\n\n閉じた仲間意識を作りながら、同時に新しい人が参加できる余白も残す。\n\nこの二重性が、DSMらしいコミュニティの作り方です。",
      },
      {
        index: "09",
        title:
          "フットボールはスポーツではなく、所属を可視化する服である",
        text:
          "フットボールシャツ、チームスカーフ、スタジアムジャケット、DSM FCの表記。\n\nDSM Kei Ninomiyaには、フットボール文化が繰り返し現れます。\n\nフットボールウェアは、競技のための機能服であると同時に、誰を支持し、どの街に属し、誰と行動するかを示す服です。\n\n同じ色と紋章を身に着けた人々が集まり、個人を集団へ変える。\n\n2026SSの学校と同様、フットボールも所属を作る制度です。\n\n二宮が引用しているのはスポーティーな見た目だけではありません。\n\n服が群衆を作る力です。",
      },
      {
        index: "10",
        title:
          "noirが素材を接続するなら、DSMは文化を接続する",
        text:
          "noir kei ninomiyaでは、レザー、チュール、金属、ハーネス、スタッズ、花、フリルなどが反復され、一つの立体へ組み上げられます。\n\n異なる小さなパーツを接続し、身体の周囲へ大きな構造を作る。\n\nDSM Kei Ninomiyaでも接続は続いています。\n\nただし、接続される対象が変わりました。\n\n学校とストリート。\nフットボールとファッション。\nパンクと制服。\nスポーツとクラフト。\n若者と高齢者。\n店舗スタッフと著名人。\n\nnoirが素材の単位から服を構築するなら、DSMは文化の単位から共同体のワードローブを構築します。",
      },
      {
        index: "11",
        title:
          "両ブランドは違うが、二宮啓の方法は断絶していない",
        text:
          "DSM Kei Ninomiyaをnoirと完全に無関係なブランドとして扱うことも不十分です。\n\n目的と商品は異なりますが、二宮啓の根本的な方法には連続性があります。\n\n完成した構造を疑う。\n既存の接続方法を変える。\n小さな単位を反復する。\n異なるものを隣接させる。\n一つの正解へ閉じない。\n\nnoirでは、“服は縫製によって作られる”という前提を疑いました。\n\nDSMでは、“ブランドは一人のデザイナーと一つのテイストによって定義される”という前提を疑っています。\n\n対象は変わっても、既存の完成形を疑う姿勢は同じです。",
      },
      {
        index: "12",
        title:
          "Beautiful Chaosは、雑多に混ぜることではない",
        text:
          "Dover Street Marketを説明する言葉として、Beautiful Chaosが使われます。\n\nこれは、異なる物を無秩序に集めることではありません。\n\nラグジュアリーとストリート。\n著名ブランドと無名の若手。\n商品とアート。\n整った什器と壊れたような空間。\n\n価値基準の異なるものを、どちらかへ統一せず共存させることです。\n\nDSM Kei Ninomiyaも同じ構造を持ちます。\n\n制服とパンク。\n規律と反抗。\nチームへの所属と個人の自由。\n日常着と実験的造形。\n\n反対する要素を解決せず、一着の中へ残す。\n\n混沌を整理するのではなく、混沌が美しく機能する関係を設計しています。",
      },
      {
        index: "13",
        title:
          "2027SS OUR PUNKで、テーマは学校から反抗へ移った",
        text:
          "2027SSでは、DSM Kei NinomiyaはPitti Uomo 110のゲストデザイナーとして初のランウェイを発表しました。\n\nテーマは“OUR PUNK”。\n\nタータン、安全ピン、スタッズ、チェーン、ダメージ、バッジ、レザー、Vansなど、パンクを想起させる記号が使われています。\n\n一見すると、2026SSの学校から正反対へ移ったように見えます。\n\nしかし、学校とパンクは完全な反対ではありません。\n\nどちらも服によって所属を示す文化です。\n\n制服が制度への所属を示すなら、パンクの服は制度への異議と別の集団への所属を示す。\n\nDSMが研究し続けているのは、服が人を集団へ変える仕組みなのです。",
      },
      {
        index: "14",
        title:
          "パンクの本質は、スタッズではなくDIYにある",
        text:
          "パンクファッションは、レザー、タータン、安全ピン、鋲、破れたTシャツによって認識されます。\n\nしかし、表面的な記号だけを再現すれば、パンクは完成された様式になります。\n\n本来の重要性は、自分で作り変えることにあります。\n\n高価な完成品を受け入れない。\n既存の服を切る。\n留める。\n破る。\n書く。\n別の用途を与える。\n\nnoirで二宮が行ってきた、通常の縫製へ依存せず服を構築する方法も、広い意味ではDIY的です。\n\n2027SSでは、その技術的な反抗が、パンクという文化的な反抗へ接続されました。",
      },
      {
        index: "15",
        title:
          "“OUR”は、パンクを二宮啓一人の所有物にしない",
        text:
          "コレクション名が“MY PUNK”ではなく、“OUR PUNK”であることは重要です。\n\n二宮の髪型や服装からは、パンクへの個人的な親和性が見えます。\n\nしかし、ブランドは二宮自身のパンクだけを正解として提示していません。\n\n過去のパンクス。\n現在の若者。\nDSMのスタッフ。\nモデル。\n顧客。\nスポーツを好む人。\nファッションを好む人。\n\nそれぞれが異なる入口から参加できるよう、所有格を複数形にしています。\n\nパンクを歴史的な衣装として保存するのではなく、共同体が更新できる共有物へ変えたのです。",
      },
      {
        index: "16",
        title:
          "OUR PUNKは、懐古的なパンク復刻ではない",
        text:
          "安全ピンやタータンを使うだけなら、1970年代のパンクを参照したコレクションはすでに数多く存在します。\n\nDSM Kei Ninomiyaの違いは、それらを現代のスポーツウェア、制服、フットボール、スケートシューズへ接続したことです。\n\nパンクを博物館の中へ戻すのではなく、今の若者がすでに着ている服へ侵入させる。\n\nトラックジャケットにスタッズが付く。\nフットボールシャツが破壊される。\nVansのチェッカーボードへ別の図像が重なる。\n\n過去のスタイルを再現するのではなく、現在の均質な日常着へ疑問を差し込みます。",
      },
      {
        index: "17",
        title:
          "Vansは、パンクと日常の間をつなぐ",
        text:
          "2027SSではVansとの協業も提示されました。\n\nVansのSlip-Onは、スケート、音楽、ストリート、DIY文化と結び付く一方、現在では誰もが知る日常的な定番靴です。\n\nつまり、サブカルチャーの内部と一般的な日常の両方に属しています。\n\nDSM Kei Ninomiyaにとって重要なのは、希少な歴史資料を使うことだけではありません。\n\nすでに多くの人が履き方を知っている定番へ、小さな異物を加えること。\n\nアクセスしやすさを失わず、既存の意味を少し不安定にする。\n\nVansは、DSMブランドの目的を最も簡潔に示す素材です。",
      },
      {
        index: "18",
        title:
          "二宮啓の外見を、そのままブランドコンセプトにしてはいけない",
        text:
          "二宮啓のモヒカン、黒い服、鋲やレザーを多用する造形から、パンクへの関係を読み取ることはできます。\n\nしかし、デザイナー本人の外見だけから、ブランド全体を“パンクブランド”と断定するのは危険です。\n\nnoirでは、パンクの記号だけでなく、花、ロマンティシズム、クチュール、数学的反復、未来的な素材が共存してきました。\n\nDSMでも、パンクは固定された永続テーマではありません。\n\n初回は学校とフットボール。\n次にOUR PUNK。\n今後は別のテーマへ変わる可能性がある。\n\nパンクはブランドの完成した定義ではなく、現時点で共同体を考えるために選ばれた一つの言語です。",
      },
      {
        index: "19",
        title:
          "DSM Kei Ninomiyaは、完成しないブランドである",
        text:
          "Dover Street MarketはDSMブランドを、“Untitled, Untethered, Undefined”と説明しています。\n\n題名を固定しない。\n何かへつなぎ留めない。\n定義しない。\n\n通常、ブランドは認知を高めるために、変わらないロゴ、商品、顧客像、価格帯を確立します。\n\nしかしDSMブランドは、今後、異なるデザイナー、パートナー、カテゴリー、規模のプロジェクトを内包する構想を持っています。\n\nDSM Kei Ninomiyaも、現在の服だけで完成するものではありません。\n\n二宮のデザインを核にしながら、他者の参加と変化を前提とする。\n\nブランドのアイデンティティを完成品ではなく、更新される過程として扱っています。",
      },
      {
        index: "20",
        title:
          "ブランドではなく、器として設計されている",
        text:
          "DSMは自らのブランドを、さまざまな創造的試みを育てる“vessel”として説明しています。\n\n器は、中に入るものによって意味が変わります。\n\n二宮啓。\nDSMのスタッフ。\n外部の協業相手。\n着用者。\n次のシーズン。\n今後参加する別のクリエイター。\n\n一人の作者が完成品を供給する従来型ブランドとは異なり、複数の声を受け入れる構造そのものを作っています。\n\nEnclopediaでは、DSM Kei Ninomiyaを一つのスタイルとしてではなく、他者が入る余白を持った服のプラットフォームとして捉えます。",
      },
      {
        index: "21",
        title:
          "Noir Kei Ninomiyaの服は身体を変え、DSMの服は関係を変える",
        text:
          "noir kei ninomiyaの代表的な服は、着用者の輪郭を大きく変えます。\n\n花の塊が身体を包む。\nハーネスが胴体を分割する。\nチュールの球体が身体の周囲へ広がる。\n金属の接続が新しい骨格を作る。\n\n一方、DSM Kei Ninomiyaの服は、着用者同士の関係を変えます。\n\n同じクレストを身に着ける。\n同じチームスカーフを巻く。\n異なる年齢の人が同じフットボールシャツを着る。\n制服をそれぞれの方法で着崩す。\n\nnoirが一人の身体へ作用するなら、DSMは複数の身体の間へ作用する。\n\nこれが両ブランドの最も大きな違いです。",
      },
      {
        index: "22",
        title:
          "Noir Kei Ninomiyaが芸術的でDSMが商業的、という単純な上下関係ではない",
        text:
          "Noir Kei Ninomiyaは複雑な構造を持ち、DSMは日常着に近い。\n\nその違いから、Noir Kei Ninomiyaを純粋な創造、DSMを販売向けの商品と見ることもできます。\n\nしかし、アクセスしやすさは創造性の欠如ではありません。\n\n多くの人が着られる既知の服を使いながら、所属、共同体、店舗、文化の関係を再設計する。\n\nこれは、立体造形とは異なる難しさを持ちます。\n\nnoirでは、見たことのない形を作る。\n\nDSMでは、見慣れた服へ、まだ存在しない共同体の意味を与える。\n\n実験の対象が異なるだけで、どちらも既存の服の役割を更新しています。",
      },
      {
        index: "23",
        title:
          "DSM Kei Ninomiyaを理解すると、Noir Kei Ninomiyaの見え方も変わる",
        text:
          "DSM Kei Ninomiyaは、Noir Kei Ninomiyaから離れるためだけのブランドではありません。\n\n新しいプロジェクトとの比較によって、Noir Kei Ninomiyaの固有性も明確になります。\n\nなぜnoirは黒を中心にしてきたのか。\nなぜ複雑な接続技術が必要なのか。\nなぜ日常着より、身体の周囲へ構造を作るのか。\nなぜ女性服という枠を使いながら、性別を越えて着られてきたのか。\n\nDSMの分かりやすい文化的テーマを見ることで、noirがどれほど技術と造形そのものへ集中したブランドなのかが分かります。\n\n新ブランドは、既存ブランドを古くするのではなく、その輪郭を鮮明にします。",
      },
      {
        index: "24",
        title:
          "新しいDSMの情報検索から、Noir Kei Ninomiyaのアーカイブ価値へ接続できる",
        text:
          "DSM Kei Ninomiyaは始動したばかりであり、中古市場で流通するアーカイブもまだ限られています。\n\n一方、二宮啓が長年積み重ねてきたnoir kei ninomiyaには、技術、素材、テーマの変化を確認できる多数のシーズンがあります。\n\n初期の黒いスタッズ構造。\nレザーとチェーン。\nチュール。\nハーネス。\n花。\n蛍光色。\n立体的なドレス。\n日常着へ近いジャケットやニット。\n\nDSMを知ったことを入口に、二宮啓の過去の仕事を見直すことができます。\n\n現在の新しさは、過去作の価値を消すのではなく、新しい比較軸を与えます。",
      },
      {
        index: "25",
        title:
          "noir kei ninomiya買取では、黒い服というだけで判断しない",
        text:
          "noir kei ninomiyaの査定では、ブランド名と色だけでは価値を判断できません。\n\nどのシーズンか。\nランウェイ登場作か。\nスタッズ、リング、チェーン、ハーネスが構造へ関係しているか。\n立体パーツの欠損はないか。\n特殊素材の劣化はないか。\n付属パーツが残っているか。\n日常着として需要のある型か。\nブランドを象徴するコレクションピースか。\n\n同じ黒いジャケットでも、通常縫製のベーシックな型と、二宮独自の接続技術を持つ型では評価軸が異なります。\n\nEnclopediaでは、二宮啓のキャリアと服の構造を確認したうえで査定します。",
      },
      {
        index: "26",
        title:
          "ノワールケイニノミヤ買取は、着用困難な作品も相談できる",
        text:
          "noir kei ninomiyaには、保管や着用が難しい作品があります。\n\nチュールが広がりすぎる。\n金属パーツが重い。\nハーネスの着用方法が分からない。\nパーツの一部が外れている。\nランウェイピースか市販品か判断できない。\n\nそのような服も、一般的な日常着と同じ基準だけで判断すべきではありません。\n\n全体写真、ブランドタグ、品質表示、接続部分、付属品をLINEで送ることで、事前に相談できます。\n\nアイテム名やシーズンが不明でも、構造やディテールから確認します。",
      },
      {
        index: "27",
        title:
          "Enclopediaの買取は、noirだけに限定されない",
        text:
          "DSM Kei Ninomiyaとnoirを知ることは、COMME des GARÇONS全体や、構造的なデザイナーズブランドを見直す入口になります。\n\nEnclopediaでは、noir kei ninomiyaのほか、COMME des GARÇONS、COMME des GARÇONS HOMME PLUS、JUNYA WATANABE、sacai、Yohji Yamamoto、Maison Margiela、Rick Owens、Simone Rocha、Cecilie Bahnsenなど、国内外のブランドを取り扱います。\n\n一着だけでも、複数ブランドをまとめても相談できます。\n\n買取ページへ個別掲載されていないブランドも、対象外とは限りません。",
      },
      {
        index: "28",
        title:
          "noir kei ninomiyaは、実際に着ると構造の意味が変わる",
        text:
          "noirの服は、ランウェイ写真だけでは着用感を理解しにくいブランドです。\n\nスタッズの重量。\nハーネスの締まり方。\nチュールが身体から離れる距離。\n肩や背中へ生まれるボリューム。\n光を受けた金属の動き。\n歩いたときの揺れ。\n\n造形作品のように見える服も、身体へ乗せると可動域や重心を持った衣服として現れます。\n\nEnclopediaのレンタルでは、二宮啓の構造を画像として見るだけでなく、身体上で確かめることができます。",
      },
      {
        index: "29",
        title:
          "DSMの共同体は、Enclopediaのレンタル思想にも接続する",
        text:
          "Dover Street Marketが、異なるブランドと人々を一つの空間へ集める場所だとすれば、Enclopediaも異なるアーカイブを所有だけに閉じず、複数の着用者へつなぐことを目指しています。\n\n一人の所有者のクローゼットに留まっていた服が、別の身体へ移る。\n\n読む人。\n売る人。\n借りる人。\n購入する人。\n\n服を中心に異なる関係が生まれる。\n\nDSM Kei Ninomiyaが共同体のための服を作るように、Enclopediaはアーカイブを介して一時的な着用の共同体を作ります。",
      },
      {
        index: "30",
        title:
          "DSM Kei Ninomiyaとは、服の完成より参加の余地を作るブランドである",
        text:
          "では、DSM Kei Ninomiyaとは何か。\n\nnoir kei ninomiyaのメンズ版ではない。\n二宮啓のパンク趣味だけを商品化したブランドでもない。\nDover Street Marketのロゴグッズでもない。\n\nDSMに集まる異なる人々が、共通のテーマを持ちながら、それぞれの方法で着るための服です。\n\n学校。\nチーム。\nフットボール。\nパンク。\n\nこれらはすべて、個人を集団へつなぐ一方で、着方によって個人差を生む文化です。\n\n二宮は完成された共同体を提示していません。\n\n着る人が参加することで初めて形になる余白を作っています。\n\nEnclopediaでは、その未完成性こそDSM Kei Ninomiyaのコンセプトだと考えます。",
      },
    ],
  
    quote:
      "noir kei ninomiyaが一着の内部へ構造を作るなら、DSM Kei Ninomiyaは服の外側にいる人々の間へ、まだ名前のない所属を作る。",
  
    perspectiveTitle:
      "EnclopediaはDSM Kei Ninomiyaを“noirのメンズライン”ではなく、“Dover Street Marketという場所を、参加できる服へ変換するブランド”として扱う。",
  
    perspectiveCards: [
      {
        number: "01",
        title: "STRUCTURE",
        text:
          "noirでは素材と接続方法から立体を作り、DSMでは学校、スポーツ、パンクなどの文化コードから共同体のワードローブを作ります。",
      },
      {
        number: "02",
        title: "COMMUNITY",
        text:
          "DSMへ集まるスタッフ、顧客、ブランド、友人を匿名的なチームとして捉え、誰でも参加できる所属の記号を服へ与えます。",
      },
      {
        number: "03",
        title: "UNDEFINED",
        text:
          "固定したメンズ像やブランドスタイルを完成させず、テーマ、協業相手、着用者によって更新される器として設計されています。",
      },
    ],
  
    experienceTitle:
      "DSM Kei Ninomiyaを入口に、二宮啓とCOMME des GARÇONSのアーカイブを売る・借りる・比較する。",
  
    experienceBody:
      "DSM Kei Ninomiyaは始動したばかりのブランドです。\n\nそのため、現在の中古市場やレンタル市場で流通する作品は、noir kei ninomiyaほど多くありません。\n\nしかし、新ブランドの成立によって、二宮啓がnoirで何を研究してきたのかは、より明確になりました。\n\nスタッズによる接続。\nリングとチェーン。\nハーネス。\nチュール。\n花。\n反復。\n身体を覆う立体構造。\n\nEnclopediaでは、DSM Kei Ninomiyaの最新情報を紹介するだけで終わらせず、過去のnoir kei ninomiyaやCOMME des GARÇONSの価値を読み直し、買取とレンタルへつなげます。\n\n所有しているnoir kei ninomiyaの価値を確認したい方は、LINEから写真査定を依頼できます。\n\n実際に二宮啓の構造を身体で確かめたい方は、Enclopediaでレンタルできるnoir kei ninomiyaとファッションアーカイブ全体をご覧ください。",
  
    experienceItems: [
      "正式表記がDSM Kei Ninomiyaであることを確認する",
      "DMS Kei Ninomiyaは検索時に生じやすい誤表記として区別する",
      "DSM Kei Ninomiyaかnoir kei ninomiyaかブランドタグを確認する",
      "noirの場合は品番、シーズン、サイズ、素材表記を確認する",
      "ランウェイルックまたは代表的なコレクション作品か確認する",
      "スタッズ、リング、チェーン、ハーネスなど接続方法を撮影する",
      "チュール、花、立体パーツの潰れや欠損を確認する",
      "特殊な着用方法がある場合は付属パーツを揃える",
      "タグ、ハンガー、ガーメント、替えパーツの有無を確認する",
      "DSMの場合はスクール、フットボール、OUR PUNKなどテーマを確認する",
      "Vans、Gloverallなど協業相手のタグや付属品を確認する",
      "noir以外のCOMME des GARÇONS系列ブランドもまとめて相談する",
      "シーズンが不明な場合もLINEで全体とタグの写真を送る",
    ],
  
    archiveItemsTitle:
      "DSM Kei Ninomiyaを知ることから、noir kei ninomiyaとデザイナーズブランド全体の買取・レンタルへ。",
  
    archiveItemsBody:
      "Enclopediaでは、DSM Kei Ninomiyaだけに対象を限定しません。二宮啓のキャリアを形成したnoir kei ninomiya、COMME des GARÇONSをはじめ、構造、素材、サブカルチャー、共同体を異なる方法で扱ってきた国内外のデザイナーズブランドを査定・レンタルしています。",
  
    archiveItems: [
      {
        label: "BUYBACK FOCUS 01",
        title: "noir kei ninomiyaの買取を相談する",
        productPath: "/brand_buyback/noir-kei-ninomiya",
        productImage: "",
        text:
          "シーズン、ランウェイでの位置付け、接続技術、立体パーツ、素材、状態を確認し、noir kei ninomiyaの価値を査定します。",
      },
      {
        label: "BUYBACK FOCUS 02",
        title: "複数ブランドをまとめてLINE査定する",
        productPath: "https://line.me/R/ti/p/@240yzqkh",
        productImage: "",
        text:
          "noir kei ninomiya、COMME des GARÇONS、JUNYA WATANABE、sacai、Maison Margielaなどをまとめて相談できます。",
      },
      {
        label: "RENTAL FOCUS 03",
        title: "レンタルできるnoir kei ninomiyaを見る",
        productPath:
          "/brand/NOIR%20KEI%20NINOMIYA（ノワールケイニノミヤ）/?number=50",
        productImage: "",
        text:
          "写真だけでは分からない重量、立体、ハーネス、金属パーツ、身体との距離を実際に着て確認できます。",
      },
      {
        label: "RENTAL FOCUS 04",
        title: "Enclopediaの全レンタルアイテムを見る",
        productPath: "/",
        productImage: "",
        text:
          "noirだけに限定せず、COMME des GARÇONS、sacai、Maison Margiela、Raf Simonsなどのアーカイブを横断して体験できます。",
      },
    ],
  
    buybackGuide: {
      label: "BUYBACK / NOIR AND DESIGNER ARCHIVE",
  
      title:
        "DSM Kei Ninomiyaを知った今、所有しているnoir kei ninomiyaの構造を見直す。",
  
      body:
        "noir kei ninomiyaの価値は、ブランドタグだけで決まりません。\n\nどの時期の二宮啓が作ったのか。\n通常の縫製とは異なる接続方法が使われているか。\n身体の周囲へどのような立体を作るのか。\nランウェイで重要な役割を持った作品か。\nパーツや付属品が残っているか。\n\nEnclopediaでは、noir kei ninomiya買取、ノワールケイニノミヤ買取の検索に応えるだけでなく、服の構造とコレクション背景を確認した査定を目指します。\n\nシーズン、商品名、購入時期が分からない場合も、LINEで全体写真、ブランドタグ、品質表示、特徴的な接続部分をお送りください。\n\nnoir以外のデザイナーズブランドも、まとめて相談できます。",
  
      buttonLabel:
        "noir kei ninomiyaをLINEで事前査定する",
  
      buttonHref:
        "https://line.me/R/ti/p/@240yzqkh",
    },
  
    rentalGuide: {
      label: "RENTAL / NOIR AND COMPLETE ARCHIVE",
  
      title:
        "DSMの共同体を知ったら、異なるブランドの構造を実際に着て比較する。",
  
      body:
        "noir kei ninomiyaの服は、写真で見る立体作品と、身体に乗せた衣服で意味が変わります。\n\n重さ。\n硬さ。\n透け。\n揺れ。\n締め付け。\n身体から離れる距離。\n\nこれらは商品画像だけでは理解できません。\n\nEnclopediaでは、noir kei ninomiyaレンタル、ノワールケイニノミヤレンタルを入口に、COMME des GARÇONS、JUNYA WATANABE、sacai、Maison Margiela、Raf Simonsなど、異なる方法で身体と服を更新してきたアーカイブを横断して体験できます。",
  
      buttonLabel:
        "レンタルできる全アイテムを見る",
  
      buttonHref:
        "/",
    },
  
    faq: {
      label: "FAQ / DSM KEI NINOMIYA",
  
      title:
        "DSM Kei Ninomiyaについて、検索されやすい疑問。",
  
      items: [
        {
          question:
            "DMS KEI NINOMIYAとDSM Kei Ninomiyaは同じブランドですか？",
          answer:
            "正式名称はDSM Kei Ninomiyaです。DSMはDover Street Marketの略称です。DMS KEI NINOMIYAは文字順を入れ替えた誤表記として検索される場合があります。",
        },
        {
          question:
            "DSM Kei Ninomiyaとは何ですか？",
          answer:
            "Dover Street Marketが始動した初のオリジナルブランドにおける最初のプロジェクトです。noir kei ninomiyaの二宮啓がデザインを担当し、DSMへ集まる多様な人々とコミュニティを出発点にしています。",
        },
        {
          question:
            "DSM Kei Ninomiyaはnoir kei ninomiyaのメンズラインですか？",
          answer:
            "単純なメンズラインではありません。Pitti Uomoでメンズコレクションを発表していますが、公式にはnoirとは異なる独立したブランドで、年齢やジェンダーを限定しない位置付けです。",
        },
        {
          question:
            "noir kei ninomiyaとの違いは何ですか？",
          answer:
            "noirは特殊な接続技術、黒、立体構造、身体表現を中心とする二宮啓自身のブランドです。DSM Kei NinomiyaはDover Street Marketの思想を起点に、学校、スポーツ、パンクなどのテーマを通して共同体のための服を作ります。",
        },
        {
          question:
            "DSM Kei Ninomiyaのコンセプトは何ですか？",
          answer:
            "固定された一つのスタイルではなく、DSMへ集まる異なる人々が互いに影響し合う状態を服へ変換することです。ブランド自体も、題名、境界、定義へ固定されない実験の器として構想されています。",
        },
        {
          question:
            "OUR PUNKとは何ですか？",
          answer:
            "DSM Kei Ninomiyaが2027年春夏に発表したコレクションテーマです。過去のパンクファッションを一人の正解として復刻するのではなく、異なる世代や背景を持つ人々が共有し、更新するパンクとして提示されました。",
        },
        {
          question:
            "noir kei ninomiyaは買取できますか？",
          answer:
            "Enclopediaではnoir kei ninomiyaの買取相談を受け付けています。シーズンや商品名が不明な場合も、全体、ブランドタグ、品質表示、ディテールの写真から確認します。",
        },
        {
          question:
            "noir kei ninomiyaをレンタルできますか？",
          answer:
            "Enclopediaでは在庫のあるnoir kei ninomiyaのアーカイブをレンタルできます。掲載状況やサイズは各商品ページをご確認ください。",
        },
      ],
    },
  
    finalCta: {
      title:
        "DSM Kei Ninomiyaを知ることから、二宮啓が作ってきた構造を売る・着る・次へつなぐ。",
  
      body:
        "DSM Kei Ninomiyaは、noir kei ninomiyaを男性用へ変えたブランドではありません。\n\n二宮啓がDover Street Marketという場所を見つめ、そこへ集まる異なる人々のために、共有できる服を作るプロジェクトです。\n\nnoirが一着の内部へ新しい構造を作るなら、DSMは服を着る人々の間へ、まだ名前のない所属を作る。\n\n新しいブランドを理解することで、過去のnoir kei ninomiyaも別の角度から見直せます。\n\n所有しているnoir kei ninomiya、COMME des GARÇONS、JUNYA WATANABEなどの価値を確認したい方は、複数ブランドをまとめてLINE査定へ。\n\n二宮啓の構造や、国内外のファッションアーカイブを実際に着て確かめたい方は、Enclopediaのレンタルアイテムをご覧ください。",
  
      primaryButtonLabel:
        "ブランド服をまとめてLINE査定する",
  
      primaryButtonHref:
        "https://line.me/R/ti/p/@240yzqkh",
  
      secondaryButtonLabel:
        "レンタルできる全アイテムを見る",
  
      secondaryButtonHref:
        "/",
    },
  };
  
  export default collection;